import { AVISO_PRIVACIDAD, COMPANY, DOMICILIO, QUIENES_SOMOS, RESPONSABLE, TERMINOS } from "./legalTexts";

export const DEFAULT_CONTENT = {
  hero: {
    eyebrow: "Tecnología para empresas · Red comercial de distribuidores",
    title: "Bienvenido a una nueva generación de redes de mercadeo",
    line_1: "Aquí tú no eres",
    line_2: "el cliente.",
    line_3: "Tú nos ayudas",
    line_4: "a conseguirlos.",
    text: "En HAPPY PEOPLE FACTORY desarrollamos soluciones digitales que las empresas necesitan para vender más, atender mejor a sus clientes y aprovechar las nuevas tecnologías.",
    text_2: "Nuestra comunidad comercial conecta estas soluciones con empresas y negocios que pueden necesitarlas.",
    flow_lines: [
      "Ellos contratan.",
      "Ellos reciben el servicio.",
      "La empresa factura.",
      "Y nuestra red comercial participa de los ingresos mediante comisiones.",
    ],
    cta_primary: "Quiero conocer la oportunidad",
    cta_secondary: "Quiero ser distribuidor",
    flow: ["Empresas", "Happy People Factory", "Red de distribuidores", "Comisiones"],
    flow_notes: ["Contratan y pagan servicios reales", "Desarrolla y entrega la tecnología", "Conecta soluciones con negocios", "Según el plan de compensación vigente"],
  },
  marquee: {
    items: ["Cliente real", "Servicio real", "Facturación real", "Conectamos personas", "Conectamos empresas", "Creamos oportunidades"],
  },
  principio: {
    eyebrow: "Nuestro principio",
    title_lines: ["Primero debe existir", "un cliente real."],
    quote: "No queremos construir una economía basada únicamente en participantes comprándose unos a otros.",
    paragraphs: [
      "Queremos desarrollar una red comercial que genere ventas hacia el mercado real.",
      "Cada empresa que contrata nuestros servicios obtiene una solución concreta y nosotros obtenemos ingresos derivados de esa relación comercial.",
      "De esa facturación puede surgir la compensación para nuestra red.",
    ],
    chain: ["Cliente real", "Servicio real", "Facturación real", "Comisiones"],
    chain_notes: ["Una empresa con una necesidad", "Una solución digital concreta", "Ingresos por una relación comercial", "Conforme al plan vigente"],
  },
  soluciones: {
    eyebrow: "¿Qué vendemos?",
    title_lines: ["Tecnología", "para empresas."],
    text: "HAPPY PEOPLE FACTORY desarrolla y comercializa diferentes soluciones digitales para empresas y comercios de distintos sectores. Esto es lo que tu red conecta con el mercado.",
    price_prefix: "Desde",
    price_empty: "Precio a consultar",
    plans_title: "Planes disponibles",
    plans_text: "Planes de servicio para empresas. Precios y condiciones sujetos a cambios.",
  },
  pasos: {
    eyebrow: "¿Cómo funciona?",
    title_lines: ["Cinco pasos.", "Sin complicaciones."],
    text: "Una explicación sencilla de cómo se conecta tu actividad con clientes reales.",
    steps: [
      { title: "Te registras", text: "Formas parte de nuestra comunidad comercial." },
      { title: "Conoces nuestras soluciones", text: "Te proporcionamos herramientas y capacitación para comprender qué problemas empresariales puede resolver cada servicio." },
      { title: "Encuentras o recomiendas clientes", text: "Identificas negocios o empresas que podrían beneficiarse de nuestras soluciones." },
      { title: "La empresa contrata", text: "El cliente decide libremente si alguno de nuestros servicios resulta adecuado para su negocio." },
      { title: "Se generan comisiones", text: "Cuando existen operaciones comerciales elegibles, se calculan las comisiones correspondientes de acuerdo con nuestro plan de compensación." },
    ],
  },
  celular: {
    eyebrow: "No necesitas ser experto en ventas",
    title_lines: ["Tu principal", "herramienta puede", "ser tu celular."],
    nots: [
      "No necesitas ser programador.",
      "No necesitas desarrollar aplicaciones.",
      "No necesitas ser experto en inteligencia artificial.",
      "Y tampoco necesitas tener experiencia previa en redes de mercadeo.",
    ],
    text: "HAPPY PEOPLE FACTORY busca proporcionar herramientas, capacitación, presentaciones y sistemas digitales que ayuden al distribuidor durante el proceso comercial.",
    closing_1: "Tú generas conexiones.",
    closing_2: "La tecnología nos ayuda a hacer el resto.",
    app_name: "HPF Conecta",
  },
  dinero: {
    eyebrow: "Nuestras soluciones",
    title: "Te presentamos algunas de las soluciones digitales que ofrecemos al mercado y que podrás comercializar con tu MEMBRESÍA DORADA, obteniendo las máximas ganancias.",
    market_label: "Mercado potencial en América Latina",
    items: [
      { name: "LUMIX", description: "Plataforma educativa para niños de 6 a 14 años. Educa con el poder de la Inteligencia Artificial.", market: "100 millones de niños" },
      { name: "CHALAN", description: "Punto de venta para pequeños negocios. Solo requieren un celular: el sistema se opera con comandos de voz.", market: "12.9 millones de pequeños negocios" },
      { name: "MULTICONTACTOS", description: "Plataforma para hacer Marketing Digital sin necesidad de tener conocimientos técnicos.", market: "7.6 millones de negocios" },
      { name: "OPINADERO", description: "Marketing especializado en crear bases de datos y campañas de lealtad para todo tipo de empresas.", market: "15 millones de comercios" },
      { name: "SIN FRAUDE", description: "Plataforma especializada para evitar los fraudes digitales en celulares.", market: "200 millones de celulares" },
      { name: "SYNAPSIS", description: "Plataforma para crear software comercial sin necesidad de saber programar código.", market: "10 millones de usuarios" },
      { name: "TU MUSIKA", description: "Plataforma para crear canciones de todo tipo a partir de escribir tu historia.", market: "20 millones de usuarios" },
    ],
  },
  membresia: {
    eyebrow: "Membresía Dorada",
    title: "Un solo paquete. Todas las ventajas.",
    price: "299",
    currency: "USD",
    price_note: "Pago único anual en USDC o USDT (red Polygon).",
    intro: "La MEMBRESÍA DORADA te da acceso completo a la red comercial de HAPPY PEOPLE FACTORY y a la máxima participación en las ganancias.",
    benefits: [
      { title: "Derrama económica global", text: "Participa de la venta de membresías doradas de tu grupo en 190 países." },
      { title: "Máximo porcentaje de ganancia", text: "Ventaja comercial al obtener el máximo porcentaje de ganancias por la venta de cualquier plataforma digital de HPF." },
      { title: "Eventos en vivo", text: "Invitación prioritaria a los eventos en vivo de HPF." },
      { title: "Descuentos en desarrollo con IA", text: "Descuentos especiales en el desarrollo de productos digitales hechos con Inteligencia Artificial." },
    ],
    cta: "Obtener mi Membresía Dorada",
    cta_secondary: "Ya tengo cuenta",
    wallet: "0xd27D8e6d92382668A0F0a3C769A5df2beFb6b4e7",
    platforms_eyebrow: "Beneficio exclusivo",
    platforms_title: "Plataformas 100% para ti",
    platforms_text: "Con tu Membresía Dorada, el pago del paquete básico de estas plataformas es íntegramente para el distribuidor que lo ofrece al negocio.",
    platforms: [
      { name: "OPINADERO", price: "10", text: "Marketing, bases de datos y campañas de lealtad." },
      { name: "CHALAN", price: "20", text: "Punto de venta por comandos de voz desde el celular." },
      { name: "SIN FRAUDE", price: "15", text: "Protección contra fraudes digitales en celulares." },
    ],
    platforms_price_note: "USD · pago único",
    platforms_example: "Ejemplo: 10 negocios al mes con las tres plataformas = $450 USD adicionales a tus comisiones de red.",
    disclaimer: "La membresía no garantiza ingresos. Las comisiones dependen de membresías realmente pagadas dentro de tu red, conforme al plan vigente.",
  },

  filosofia: {
    eyebrow: "Nuestra filosofía",
    meaning_label: "Nuestro nombre significa:",
    meaning: "Fábrica de personas felices",
    twist: "Pero no fabricamos felicidad.",
    paragraphs: [
      "Creamos herramientas y oportunidades para que las personas puedan desarrollar nuevas actividades comerciales aprovechando tecnología, inteligencia artificial y economía digital.",
      "Creemos que una oportunidad comercial debe crear valor para todos:",
    ],
    values: [
      { title: "El cliente", text: "recibe una solución." },
      { title: "El distribuidor", text: "desarrolla una actividad comercial." },
      { title: "La empresa", text: "obtiene nuevos clientes." },
      { title: "La red", text: "crece mediante actividad económica real." },
    ],
    closing: "Cuando todos reciben valor, existe una mejor base para construir relaciones comerciales duraderas.",
  },
  manifiesto: {
    eyebrow: "Manifiesto",
    lines: [
      "No queremos que compres para poder participar.",
      "Queremos que aprendas a generar clientes.",
      "No queremos una red basada únicamente en consumo interno.",
      "Queremos una red conectada con la economía real.",
      "No vendemos la promesa de dinero fácil.",
      "Creamos herramientas para generar oportunidades comerciales.",
    ],
    closing_title: "HAPPY PEOPLE FACTORY",
    closing_text: "Tecnología que genera oportunidades.",
  },
  testimonios: {
    eyebrow: "Testimonios",
    title: "Lo que dicen de nosotros",
  },
  faq: {
    eyebrow: "Preguntas frecuentes",
    title_lines: ["Preguntas", "claras,", "respuestas", "honestas."],
    text: "Si tienes otra duda, déjanos tus datos en el formulario y te explicamos el modelo.",
  },
  cta: {
    eyebrow: "Llamado a la acción",
    title: "¿Estás listo para conocer una forma diferente de hacer network marketing?",
    text: "Puedes comenzar incluso si nunca has participado en una red de mercadeo. Conoce nuestras soluciones, aprende nuestro sistema y descubre cómo convertir relaciones y contactos empresariales en oportunidades comerciales.",
    primary: "Quiero formar parte de Happy People Factory",
    secondary: "Quiero conocer cómo funciona",
  },
  registro: {
    eyebrow: "Registro",
    title_lines: ["Da el", "primer paso."],
    text: "Déjanos tus datos para conocer la oportunidad comercial de HAPPY PEOPLE FACTORY.",
    assurances: [
      "Sin compras obligatorias para participar.",
      "Sin promesas de ingresos.",
      "Conoce el modelo antes de decidir.",
    ],
    labels: {
      first_name: "Nombre",
      last_name: "Apellidos",
      country: "País",
      state: "Estado / Provincia",
      city: "Ciudad",
      whatsapp: "WhatsApp",
      email: "Correo electrónico",
      sales_experience: "¿Tienes experiencia en ventas?",
      mlm_experience: "¿Has participado anteriormente en Network Marketing?",
      business_contacts: "¿Tienes contactos con negocios o empresas?",
      referral_code: "Código de referido o patrocinador (si existe)",
    },
    disclaimer: "He leído y entiendo que participar en HAPPY PEOPLE FACTORY no garantiza ingresos y que cualquier compensación depende de actividad comercial elegible y de las condiciones establecidas en el plan de compensación.",
    submit: "Quiero conocer la oportunidad",
    success_title: "¡Gracias por registrarte!",
    success_text: "Hemos recibido tus datos. Pronto nos pondremos en contacto contigo para presentarte la oportunidad.",
  },
  footer: {
    slogan: ["Conectamos personas.", "Conectamos empresas.", "Creamos oportunidades."],
    description: "Empresa tecnológica y comercial que desarrolla y comercializa soluciones digitales para empresas, distribuidas a través de una red comercial enfocada en clientes reales.",
    disclaimer: "Participar en HAPPY PEOPLE FACTORY no garantiza ingresos. Cualquier compensación depende de actividad comercial elegible y de las condiciones del plan de compensación vigente.",
  },
  media: {
    hero_image: "/img/hero-ejecutivos.jpg",
    principio_image: "/img/principio-cafe.jpg",
    celular_image: "/img/celular-joven.jpg",
    filosofia_image: "/img/filosofia-equipo.jpg",
    cta_image: "/img/cta-panaderia.jpg",
    soluciones_images: ["/img/sol-pedidos.jpg", "/img/sol-taqueria.jpg", "/img/sol-ferreteria.jpg"],
    manifiesto_images: ["/img/manifiesto-aprender.jpg", "/img/manifiesto-economia-real.jpg", "/img/manifiesto-herramientas.jpg"],
    video_url: "",
    video_title: "Conoce Happy People Factory en video",
  },
  compensacion: {
    show_on_site: "no",
    plan_name: "Plan de compensación vigente",
    direct_pct: "",
    team_pct: "",
    recurring_pct: "",
    notes: "Porcentajes ilustrativos sujetos al plan de compensación vigente. Solo aplican sobre actividad comercial elegible.",
  },
  paises: {
    list: ["Argentina", "Bolivia", "Chile", "Colombia", "Costa Rica", "Ecuador", "El Salvador", "España", "Estados Unidos", "Guatemala", "Honduras", "México", "Nicaragua", "Panamá", "Paraguay", "Perú", "Puerto Rico", "República Dominicana", "Uruguay", "Venezuela", "Otro"],
  },
  contacto: {
    email: "info@hpf.com",
    whatsapp: "+52 33 4280 2102",
    phone: "",
    address: DOMICILIO,
    instagram: "",
    facebook: "",
    linkedin: "",
    youtube: "",
    tiktok: "",
  },
  legal: {
    company_name: COMPANY,
    tax_id: "RFC: [RFC]",
    domicilio: DOMICILIO,
    representante: RESPONSABLE,
    terminos: TERMINOS,
    privacidad: AVISO_PRIVACIDAD,
    aviso_legal: QUIENES_SOMOS,
  },
};

const isObj = (v) => v && typeof v === "object" && !Array.isArray(v);

export function deepMerge(base, over) {
  if (!isObj(base)) return over === undefined ? base : over;
  const out = { ...base };
  if (!isObj(over)) return out;
  Object.keys(over).forEach((k) => {
    const b = base[k];
    const o = over[k];
    if (isObj(b)) out[k] = deepMerge(b, o);
    else if (Array.isArray(b)) out[k] = Array.isArray(o) ? o : b;
    else if (o !== undefined && o !== null) out[k] = o;
  });
  return out;
}
